import { render, staticRenderFns } from "./ConfigAlertGitter.vue?vue&type=template&id=7126b52a&"
import script from "./ConfigAlertGitter.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertGitter.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAlertGitter.vue?vue&type=style&index=0&id=7126b52a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports